var _rect, _path, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarketinginline = function SvgMarketinginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 45 45"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "#F3E972",
    rx: 5.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M38.746 19.107a2.71 2.71 0 0 0-1.8-2.535.677.677 0 0 0-.907.637l.01 5.176a.678.678 0 0 0 .906.635 2.71 2.71 0 0 0 1.791-2.553zM34.009 11.025a2.02 2.02 0 0 0-.948-1.705c-1.129-.718-1.988-.117-3.69.702a30.46 30.46 0 0 1-13.673 3.639.677.677 0 0 0-.64.677v11.097c0 .374.27.689.64.745 2.358.36 10.592 1.698 13.652 3.314 1.862.876 2.623 1.4 3.73.677a2.02 2.02 0 0 0 .925-1.711z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.707,
    height: 8.25,
    x: 15.059,
    y: 28.225,
    fill: "#212121",
    rx: 1.125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M13.026 14.4a.677.677 0 0 0-.677-.677l-1.371.01a4.744 4.744 0 0 0-4.72 4.761l.012 2.707a4.74 4.74 0 0 0 4.76 4.715h1.319a.677.677 0 0 0 .677-.677z"
  })));
};
export default SvgMarketinginline;